import { render, staticRenderFns } from "./MedicationAdminModal.vue?vue&type=template&id=e0b6a604&scoped=true"
import script from "./MedicationAdminModal.vue?vue&type=script&lang=js"
export * from "./MedicationAdminModal.vue?vue&type=script&lang=js"
import style0 from "./MedicationAdminModal.vue?vue&type=style&index=0&id=e0b6a604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b6a604",
  null
  
)

export default component.exports